import { useCountUp } from "@/lib/useCountUp";
import { Reveal } from "@/components/landing/Reveal";

const STATS = [
  { target: 35000, suffix: "+", label: "Animals Rescued & Treated" },
  { target: 300000, suffix: "+", label: "Animals Vaccinated" },
  { target: 1500000, suffix: "+", label: "Meals Served" },
  { target: 0, suffix: "", label: "Animals Euthanized — Ever" },
];

function StatNumeral({ target, suffix }) {
  const [value, ref] = useCountUp(target, 1400);
  return (
    <span ref={ref} className="font-display text-[clamp(1.65rem,7vw,4.5rem)] text-amtm-bg leading-none whitespace-nowrap">
      {value.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
}

export function LegacyBand() {
  return (
    <section className="bg-[#12100C] py-20 md:py-32" data-testid="landing-legacy-band">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-14 md:mb-20">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-amtm-teal mb-4">
            Our Legacy
          </p>
          <h2 className="font-display text-3xl md:text-5xl text-amtm-bg leading-tight">
            16 years. One promise: <br className="hidden md:block" /> no animal left behind.
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 gap-y-14 gap-x-4 sm:gap-x-10 md:gap-x-16 text-center">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="px-1">
              <StatNumeral target={s.target} suffix={s.suffix} />
              <p className="text-xs md:text-sm uppercase tracking-wide text-amtm-bg/60 mt-3">{s.label}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3} className="text-center mt-14 md:mt-20">
          <p className="text-amtm-bg/70 text-sm md:text-base max-w-xl mx-auto">
            AMTM is a no-kill organisation. In 16 years of operation, not a single animal has been euthanized.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
